// import React, { useEffect, useState } from 'react';
import axios from "axios";
import React, { useEffect, useState, useRef, useCallback } from "react";
import RoomEvents from "./RoomEvents";
import ListRoom from "./ListRooms";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from './pages/LoginPage';
import { LoginProvider } from './context/LoginContext';
import PrivateRoute from './components/PrivateRoute';


function App() {
  return (
    <LoginProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <ListRoom />
              </PrivateRoute>
            }
          />
          <Route
            path="/rooms/:resourceEmail/:resourceName"
            element={
              <PrivateRoute>
                <RoomEvents />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </LoginProvider>
  );
  // return (
  //   <Router>
  //     <Routes>
  //       <Route path="/" element={<ListRoom />} />
  //       <Route path="/rooms/:resourceEmail/:resourceName" element={<RoomEvents />} />
  //     </Routes>
  //   </Router>
  // );
 
}

export default App;
